// Portfolio data — single source of truth used by landing section and /portfolio page
// `categories` maps each project to the filter chips on /portfolio (All / Mobile / GIS / Gov / e-Commerce)

export const CATEGORIES = ["All", "Mobile", "GIS", "Gov", "e-Commerce", "International", "Company Profile"];

export const projects = [
  {
    key: "undp",
    title: "UNDP · River Cleanup Survey",
    category: "GIS · Mobile · Environmental Data",
    tags: ["Mobile", "GIS", "Dashboard", "Analytics"],
    categories: ["Mobile", "GIS"],
    image: "/assets/portofolio/undp_porto.png",
    span: "lg:col-span-2 lg:row-span-2",
    year: "2025",
    description:
      "Strategic collaboration with UNDP on a digital survey application focused on river cleanup monitoring and marine debris data collection. Ships with a GIS-integrated field tool, live environmental dashboards, and a mobile survey platform designed for teams on unstable connectivity.",
  },
  {
    key: "layanan-ndi",
    title: "Layanan NDI",
    category: "Gov Services · Population Admin",
    tags: ["Mobile", "Development", "Gov Tech"],
    categories: ["Mobile", "Gov"],
    image: "/assets/portofolio/layanan_ndi.png",
    span: "lg:col-span-2",
    year: "2025",
    description:
      "Mobile-first population administration platform (Layanan Administrasi Kependudukan Online) for KTP, KK, and civic documents. Citizens submit requests, track processing status in real time, and receive push notifications — reducing counter queues and paper trails.",
  },
  // {
  //   key: "yplus",
  //   title: "YPlus Indonesia",
  //   category: "e-Commerce",
  //   tags: ["Development", "SEO", "UI/UX", "Website"],
  //   categories: ["e-Commerce"],
  //   image: "/assets/portofolio/y_plus_porto.png",
  //   year: "2024",
  //   description:
  //     "E-commerce build for YPlus Indonesia — storefront, catalog architecture, and a checkout flow tuned for conversion, with SEO fundamentals baked in from day one.",
  // },
  {
    key: "jakpro",
    title: "JAKPRO",
    category: "CMS · Company Profile · Ticketing",
    tags: ["CMS", "Development", "SEO", "Website"],
    categories: ["Gov"],
    image: "/assets/portofolio/jakpro_porto.png",
    year: "2024",
    description:
      "PT Jakarta Propertindo (JAKPRO) — company profile with a headless CMS pipeline, plus Formula-E ticket sales integration for one of Jakarta's flagship provincial initiatives.",
  },
  {
    key: "amazing-thailand",
    title: "Amazing Thailand",
    category: "Tourism CMS",
    tags: ["CMS", "SEO", "Development", "Website"],
    categories: ["International"],
    image: "/assets/portofolio/amazing_thailand.png",
    year: "2023",
    description:
      "Tourism portal for Amazing Thailand — a content pipeline for destination guides, event calendars, and multi-market storytelling with responsive editorial UX.",
  },
  {
    key: "kemensekneg",
    title: "Kementrian Sekretariat Negara",
    category: "Web Dashboard · Mobile Apps",
    tags: ["CMS", "Development", "Mobile"],
    categories: ["Mobile", "Gov"],
    image: "/assets/portofolio/sekneg_porto.png",
    span: "lg:col-span-2",
    year: "2023",
    description:
      "Web dashboard and companion mobile apps for the Ministry of State Secretariat — internal workflow tooling paired with citizen-facing information channels.",
  },
  {
    key: "fomo",
    title: "FOMO Application",
    category: "Mobile App · PWA",
    tags: ["Mobile", "PWA", "UI/UX"],
    categories: ["Mobile"],
    image: "/assets/portofolio/fomo_app_porto.png",
    year: "2024",
    description:
      "FOMO — event discovery and social-feed mobile experience delivered as both native app and PWA. Offline-first UX, smart caching, and a UI system designed for daily habit use.",
  },
  {
    key: "beehealth",
    title: "BeeHealth",
    category: "Mobile App · Hybrid",
    tags: ["Mobile", "CMS", "UI/UX"],
    categories: ["Mobile"],
    image: "/assets/portofolio/bee_health_binus_porto.png",
    year: "2024",
    description:
      "BeeHealth — mobile application for health tracking and wellness management.",
  },
  {
    key: "arunika-wastra",
    title: "Arunika Wastra",
    category: "Mobile App · Hybrid",
    tags: ["Mobile", "Backend", "UI/UX"],
    categories: ["Mobile"],
    image: "/assets/portofolio/arunika_wastra_porto.png",
    year: "2019",
    description:
      "Arunika Wastra — mobile application for fashion and lifestyle e-commerce, with a focus on user engagement and seamless shopping experience.",
  },
  {
    key: "mcdeli",
    title: "MCdeli",
    category: "Company Profile",
    tags: ["Development", "SEO", "Website"],
    categories: [],
    image: "/assets/portofolio/mc_deli_porto.png",
    year: "2023",
    description:
      "Company profile and product catalog for MCdeli — an Indonesian specialist in ready-to-eat food products, with SEO-tuned content architecture.",
  },
  {
    key: "jnto",
    title: "JNTO",
    category: "Tourism Website",
    tags: ["Development", "SEO", "Website"],
    categories: ["International"],
    image: "/assets/portofolio/jnto_porto.png",
    year: "2023",
    description:
      "Official Japan National Tourism Organization portal for the Indonesian market — multilingual content, travel planners, and destination discovery flows.",
  },
  {
    key: "larusso",
    title: "LARUSSO",
    category: "e-Commerce · Fashion",
    tags: ["CMS", "Development", "Website"],
    categories: ["e-Commerce"],
    image: "/assets/portofolio/larusso_porto.png",
    year: "2021",
    description:
      "E-commerce build for LARUSSO — an Indonesian men's fashion label. Headless architecture, editorial-first storefront, and a checkout flow tuned for repeat customers.",
  },
  {
    key: "kloa-pos",
    title: "KLOA",
    category: "POS · Mobile",
    tags: ["Mobile", "POS"],
    categories: ["Mobile"],
    image: "/assets/portofolio/kloa_porto.png",
    year: "2024",
    description:
      "POS system for KLOA — an Indonesian men's fashion label. Mobile-first design, inventory management, and seamless checkout experience.",
  },
  {
    key: "ranting-ranting",
    title: "Ranting Ranting",
    category: "e-Commerce · Mobile",
    tags: ["Mobile", "e-Commerce"],
    categories: ["Mobile"],
    image: "/assets/portofolio/ranting_ranting_porto.png",
    year: "2018",
    description:
      "E-commerce mobile application for Ranting Ranting — an Indonesian fashion brand. Focused on user engagement, product discovery, and a seamless shopping experience.",
  },
  {
    key: "myway",
    title: "MyWay",
    category: "e-Commerce · Catalog",
    tags: ["CMS", "Development", "Website", "UI/UX"],
    categories: ["e-Commerce", "International"],
    image: "/assets/portofolio/my_way_porto.png",
    year: "2018",
    description:
      "E-commerce build for MyWay — E-commerce showcase platform for an Egypt-based retail brand with a focus on product catalog, user experience, and responsive design.",
  },
  {
    key: "mac",
    title: "MAC",
    category: "Business Operations · Mobile App",
    tags: ["CMS", "Development", "Website", "UI/UX"],
    categories: ["Mobile", "B2B"],
    image: "/assets/portofolio/mac_porto.png",
    year: "2018",
    description:
      "MAC — Mobile application for facility and property management operations, with a focus on task tracking, reporting, and user engagement.",
  },
  {
    key: "tis",
    title: "Tekno Parkir",
    category: "Company Profile · Parking Management",
    tags: ["CMS", "Development", "Website", "UI/UX"],
    categories: ["Company Profile"],
    image: "/assets/portofolio/tis_porto.png",
    year: "2017",
    description:
      "Tekno Parkir — Company profile for a parking management solution, highlighting services, client testimonials, and contact information.",
  },
];
